import { render, staticRenderFns } from "./Uninstall.vue?vue&type=template&id=6a7d7283&"
import script from "./Uninstall.vue?vue&type=script&lang=js&"
export * from "./Uninstall.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports